import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import english from '../../../../public/locales/en/translation.json'
import croatia from '../../../../public/locales/hr/translation.json'

import LanguageDetector from 'i18next-browser-languagedetector'

const langs = {
    en: {
        translation: english,
    },
    hr: {
        translation: croatia,
    },
}

const firstInstance = i18n
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: 'en',
        debug: true,
        resources: langs,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    })

export const secondInstance = i18n.createInstance({
    fallbackLng: 'en',
    react: {useSuspense: false},
    debug: true,
    resources: langs,
    interpolation: {
        escapeValue: false
    }
}, (err, t) => console.log(err))

export default firstInstance
